import ResizeAllRules from './ResizeAllRules';

export default {
  __init__: [ 'resizeAllRules' ],
  resizeAllRules: [ 'type', ResizeAllRules ]
};